module.exports = __webpack_public_path__ + "0442773b2e9135e5a79e48542b456944.png";